<script setup lang="ts">
import { useLocale } from '../../composables/useLocale';
import { useDisplay } from 'vuetify';

const { t } = useLocale();
const { xs } = useDisplay();

defineProps<{
  action: () => void;
  actionLabel: string;
  onReset: () => void;
}>();
</script>

<template>
  <v-row no-gutters class="flex-column align-center">
    <v-col :style="{ maxWidth: xs ? '100%' : '240px' }" class="d-flex flex-column align-center">
      <v-sheet
        rounded
        :class="{ 'pa-6': !xs, 'pa-4': xs }"
        class="bg-surface-bright d-flex flex-column align-center ga-4"
      >
        <v-icon size="64" color="primary">mdi-account-multiple</v-icon>
        <div class="text-center text-subtitle-1 font-weight-bold">{{ t('lcp.group_created_successfully') }}</div>
        <div class="text-center">{{ t('lcp.group_created_instructions') }}</div>
        <v-btn variant="tonal" :block="xs" prepend-icon="mdi-plus" @click="onReset">
          {{ t('lcp.create_another_group') }}
        </v-btn>
      </v-sheet>
    </v-col>
    <v-col
      id="create-another-group-btn"
      v-if="!xs"
      :style="{ maxWidth: xs ? '100%' : '240px' }"
      class="d-flex flex-column align-center"
    >
      <v-btn block @click="action" class="mt-6" :class="{ 'pa-6': !xs, 'pa-4': xs }">
        {{ actionLabel }}
      </v-btn>
    </v-col>
  </v-row>
</template>
